import { render, staticRenderFns } from "./CriteriaSave.vue?vue&type=template&id=fc5c258e&scoped=true&"
import script from "./CriteriaSave.vue?vue&type=script&lang=js&"
export * from "./CriteriaSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5c258e",
  null
  
)

export default component.exports